<template>
    <div class="admin container-fluid">
        <nav class="navbar">
            <div class="nav-icon d-block d-sm-none">
                <i class="fas fa-tachometer-alt" @click="overviewDisplay()"></i>
                <i class="fas fa-address-book" @click="studentDisplay()"></i>
                <i class="fas fa-search" @click="searchDisplay()"></i>
                <i class="fas fa-clipboard-check" @click="admissionDisplay()"></i>
                <i class="fas fa-certificate" @click="certificateDisplay()"></i>
            </div>
            <h3 class="navbar-title col-md-2 d-none d-sm-block">Dashboard</h3>
            <button @click="logout" class="navbar-btn">Logout</button>
        </nav>
        <div class="row">
            <div class="sidebar col-md-2 d-none d-sm-block">
                <ul>
                    <li class="sidebar-item" @click="overviewDisplay()">
                        <i class="fas fa-tachometer-alt"></i>&nbsp;Overview</li>
                    <li class="sidebar-item" @click="studentDisplay()">
                        <i class="fas fa-address-book"></i>&nbsp;&nbsp;Student</li>
                    <li class="sidebar-item" @click="searchDisplay()">
                        <i class="fas fa-search"></i>&nbsp;&nbsp;Search</li>
                    <li class="sidebar-item" @click="admissionDisplay()">
                        <i class="fas fa-clipboard-check"></i>&nbsp;&nbsp;Admission</li>
                    <li class="sidebar-item" @click="certificateDisplay()">
                        <i class="fas fa-certificate"></i>&nbsp;Certificate</li>
                </ul>
            </div>
            <div class="main col-md-10">
                <div class="overview col-md-10 offset-md-1" :style="{ display: overview_display}">
                    <div class="row">
                        <div class="col-md-3 col-10 mx-auto branch-container">
                            <div class="branch">
                                <h2 class="branch-title">Graphic</h2>
                                <h4 class="branch-count ">{{ count_graphic }} คน</h4>
                            </div>
                        </div>
                        <div class="col-md-3 col-10 mx-auto branch-container">
                            <div class="branch">
                                <h2 class="branch-title">Robot</h2>
                                <h4 class="branch-count ">{{ count_robot }} คน</h4>
                            </div>
                        </div>
                        <div class="col-md-3 col-10 mx-auto branch-container">
                            <div class="branch">
                                <h2 class="branch-title">Multimedia</h2>
                                <h4 class="branch-count ">{{ count_multimedia }} คน</h4>
                            </div>
                        </div>
                        <div class="col-md-3 col-10 mx-auto branch-container">
                            <div class="branch">
                                <h2 class="branch-title">Programing</h2>
                                <h4 class="branch-count ">{{ count_programing }} คน</h4>
                            </div>
                        </div>
                        <div class="col-md-2 col-10 mx-auto branch-container">
                            <div class="branch">
                                <h2 class="branch-title">ม.1</h2>
                                <h4 class="branch-count ">{{ count_m1 }} คน</h4>
                            </div>
                        </div>
                        <div class="col-md-2 col-10 mx-auto branch-container">
                            <div class="branch">
                                <h2 class="branch-title">ม.2</h2>
                                <h4 class="branch-count ">{{ count_m2 }} คน</h4>
                            </div>
                        </div>
                        <div class="col-md-2 col-10 mx-auto branch-container">
                            <div class="branch">
                                <h2 class="branch-title">ม.3</h2>
                                <h4 class="branch-count ">{{ count_m3 }} คน</h4>
                            </div>
                        </div>
                        <div class="col-md-2 col-10 mx-auto branch-container">
                            <div class="branch">
                                <h2 class="branch-title">ม.4</h2>
                                <h4 class="branch-count ">{{ count_m4 }} คน</h4>
                            </div>
                        </div>
                        <div class="col-md-2 col-10 mx-auto branch-container">
                            <div class="branch">
                                <h2 class="branch-title">ม.5</h2>
                                <h4 class="branch-count ">{{ count_m5 }} คน</h4>
                            </div>
                        </div>
                        <div class="col-md-2 col-10 mx-auto branch-container">
                            <div class="branch">
                                <h2 class="branch-title">ม.6</h2>
                                <h4 class="branch-count ">{{ count_m6 }} คน</h4>
                            </div>
                        </div>
                        <div class="col-md-12 col-10 mx-auto branch-container">
                            <div class="branch">
                                <h2 class="branch-title">ผู้สมัครทั้งหมด</h2>
                                <h4 class="branch-count"> {{ count }} คน</h4>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="student col-md-10 offset-md-1" :style="{ display: student_display}">
                    <div class="row">
                        <div class="branch-student col-md-10 col-10 mx-auto">
                            <button @click="branchStudent(branch)" class="col-md-2 col-5 mx-auto" v-for="(branch, index) in ['Graphic', 'Robot', 'Multimedia', 'Programing']" :key="index"> {{ branch }} </button>
                            <button @click="branch_display = 'All'" class="col-md-2 col-5 mx-auto">All</button>
                        </div>
                        <div class="table-responsive">
                            <table class="table table-hover">
                                <thead class="thead-dark">
                                    <tr>
                                        <th scope="col">#</th>
                                        <th scope="col">ชื่อ-นามสกุล</th>
                                        <th scope="col">ชื่อเล่น</th>
                                        <th scope="col">ชั้น</th>
                                        <th scope="col">สาขา</th>
                                        <th scope="col">คัดเลือก</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(student, index) in students_list" :key="index" v-if="student.branch == branch_display || branch_display == 'All'">
                                        <th scope="row">{{ student.studentid }}</th>
                                        <td>{{ student.name }} {{ student.surname }}</td>
                                        <td>{{ student.nickname }}</td>
                                        <td>{{ student.classlevel }}/{{ student.classroom }}</td>
                                        <td>{{ student.branch }}</td>
                                        <td v-if="student.choose == 'real'" style="color: #4caf50;">ตัวจริง</td>
                                        <td v-if="student.choose == 'reserve'" style="color: #ffc107">ตัวสำรอง</td>
                                        <td v-if="student.choose == null" style="color: #dc3545;">ยังไม่คัดเลือก</td>
                                        <td>
                                            <button class="student-info-btn" v-b-modal="modalId(student.studentid)">รายละเอียด</button>
                                        </td>
                                        <b-modal :id="'modal'+student.studentid" size="lg" :title="'#'+student.studentid+' '+student.name+' '+student.surname+' '+''+'('+student.nickname+')'" hide-footer>
                                            <div class="row">
                                                <div class="input-group col-md-3">
                                                    <label class="col-md-12" for="branch">สาขา</label>
                                                    <input type="text" class="form-input form-input-check col-md-12" disabled v-model="student.branch">
                                                </div>
                                                <div class="input-group col-md-3">
                                                    <label class="col-md-12" for="classlevel">ระดับชั้น</label>
                                                    <input type="text" class="form-input form-input-check col-md-12" disabled v-model="student.classlevel">
                                                </div>
                                                <div class="input-group col-md-3">
                                                    <label class="col-md-12" for="classroom">ห้อง</label>
                                                    <input type="text" class="form-input form-input-check col-md-12" disabled v-model="student.classroom">
                                                </div>
                                                <div class="input-group col-md-3">
                                                    <label class="col-md-12" for="religion">ศาสนา</label>
                                                    <input type="text" class="form-input form-input-check col-md-12" disabled v-model="student.religion">
                                                </div>
                                                <div class="input-group col-md-4">
                                                    <label class="col-md-12" for="phone">เบอร์มือถือ</label>
                                                    <input type="text" class="form-input form-input-check col-md-12" disabled v-model="student.phone">
                                                </div>
                                                <div class="input-group col-md-4">
                                                    <label class="col-md-12" for="lineid">ไลน์</label>
                                                    <input type="text" class="form-input form-input-check col-md-12" disabled v-model="student.lineid">
                                                </div>
                                                <div class="input-group col-md-4">
                                                    <label class="col-md-12" for="fburl">เฟสบุ๊ค</label>
                                                    <input type="text" class="form-input form-input-check col-md-12" disabled v-model="student.fburl">
                                                </div>
                                                <div class="input-group col-md-6">
                                                    <label class="col-md-12" for="medical">โรคประจำตัว</label>
                                                    <input type="text" class="form-input form-input-check col-md-12" disabled v-model="student.medical">
                                                </div>
                                                <div class="input-group col-md-6">
                                                    <label class="col-md-12" for="allergy">สิ่งที่แพ้</label>
                                                    <input type="text" class="form-input form-input-check col-md-12" disabled v-model="student.allergy">
                                                </div>
                                                <div class="input-group col-md-3">
                                                    <label class="col-md-12" for="name_parent">ชื่อผู้ปกครอบ</label>
                                                    <input type="text" class="form-input form-input-check col-md-12" disabled v-model="student.name_parent">
                                                </div>
                                                <div class="input-group col-md-3">
                                                    <label class="col-md-12" for="surname_parent">นามสกุลผู้ปกครอง</label>
                                                    <input type="text" class="form-input form-input-check col-md-12" disabled v-model="student.surname_parent">
                                                </div>
                                                <div class="input-group col-md-3">
                                                    <label class="col-md-12" for="relation">ความสัมพันธ์</label>
                                                    <input type="text" class="form-input form-input-check col-md-12" disabled v-model="student.relation">
                                                </div>
                                                <div class="input-group col-md-3">
                                                    <label class="col-md-12" for="phone_parent">เบอร์ผู้ปกครอง</label>
                                                    <input type="text" class="form-input form-input-check col-md-12" disabled v-model="student.phone_parent">
                                                </div>
                                                <div class="input-group col-md-12">
                                                    <label class="col-md-12" for="qAnswer_1">คำถามข้อ 1</label>
                                                    <textarea type="text" class="form-input form-input-check col-md-12" disabled v-model="student.qAnswer_1"></textarea>
                                                </div>
                                                <div class="input-group col-md-12">
                                                    <label class="col-md-12" for="qAnswer_2">คำถามข้อ 2</label>
                                                    <textarea class="form-input form-input-check col-md-12" disabled v-model="student.qAnswer_2"></textarea>
                                                </div>
                                                <button class="choose-btn" :class="{ 'choose-btn-real-active' : student.choose == 'real'}" @click="chooseStudent(student.studentid, 'real')">ตัวจริง</button>
                                                <button class="choose-btn choose-btn-reserve" :class="{ 'choose-btn-reserve-active' : student.choose == 'reserve'}" @click="chooseStudent(student.studentid, 'reserve')">ตัวสำรอง</button>
                                            </div>
                                        </b-modal>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                    </div>
                </div>
                <div class="search col-md-10 offset-md-1" :style="{ display: search_display}">
                    <div class="search-box col-md-6 col-8">
                        <input type="text" v-model="search_student[0].studentid" @change="searchStudent(search_student[0].studentid)" class="col-md-6 col-8">
                        <button @click="searchStudent(search_student[0].studentid)">
                            <i class="fas fa-search"></i>
                        </button>
                    </div>
                    <h3 v-if="search_student[1] != null">#{{ search_student[1].studentid }}</h3>
                    <div class="row" v-if="search_student[1] != null">
                        <div class="input-group col-md-4">
                            <label class="col-md-12" for="branch">ชื่อ</label>
                            <input type="text" class="form-input form-input-check col-md-12" disabled v-model="search_student[1].name">
                        </div>
                        <div class="input-group col-md-4">
                            <label class="col-md-12" for="branch">นามสกุล</label>
                            <input type="text" class="form-input form-input-check col-md-12" disabled v-model="search_student[1].surname">
                        </div>
                        <div class="input-group col-md-4">
                            <label class="col-md-12" for="branch">ชื่อเล่น</label>
                            <input type="text" class="form-input form-input-check col-md-12" disabled v-model="search_student[1].nickname">
                        </div>
                        <div class="input-group col-md-3">
                            <label class="col-md-12" for="branch">สาขา</label>
                            <input type="text" class="form-input form-input-check col-md-12" disabled v-model="search_student[1].branch">
                        </div>
                        <div class="input-group col-md-3">
                            <label class="col-md-12" for="classlevel">ระดับชั้น</label>
                            <input type="text" class="form-input form-input-check col-md-12" disabled v-model="search_student[1].classlevel">
                        </div>
                        <div class="input-group col-md-3">
                            <label class="col-md-12" for="classroom">ห้อง</label>
                            <input type="text" class="form-input form-input-check col-md-12" disabled v-model="search_student[1].classroom">
                        </div>
                        <div class="input-group col-md-3">
                            <label class="col-md-12" for="religion">ศาสนา</label>
                            <input type="text" class="form-input form-input-check col-md-12" disabled v-model="search_student[1].religion">
                        </div>
                        <div class="input-group col-md-4">
                            <label class="col-md-12" for="phone">เบอร์มือถือ</label>
                            <input type="text" class="form-input form-input-check col-md-12" disabled v-model="search_student[1].phone">
                        </div>
                        <div class="input-group col-md-4">
                            <label class="col-md-12" for="lineid">ไลน์</label>
                            <input type="text" class="form-input form-input-check col-md-12" disabled v-model="search_student[1].lineid">
                        </div>
                        <div class="input-group col-md-4">
                            <label class="col-md-12" for="fburl">เฟสบุ๊ค</label>
                            <input type="text" class="form-input form-input-check col-md-12" disabled v-model="search_student[1].fburl">
                        </div>
                        <div class="input-group col-md-6">
                            <label class="col-md-12" for="medical">โรคประจำตัว</label>
                            <input type="text" class="form-input form-input-check col-md-12" disabled v-model="search_student[1].medical">
                        </div>
                        <div class="input-group col-md-6">
                            <label class="col-md-12" for="allergy">สิ่งที่แพ้</label>
                            <input type="text" class="form-input form-input-check col-md-12" disabled v-model="search_student[1].allergy">
                        </div>
                        <div class="input-group col-md-3">
                            <label class="col-md-12" for="name_parent">ชื่อผู้ปกครอบ</label>
                            <input type="text" class="form-input form-input-check col-md-12" disabled v-model="search_student[1].name_parent">
                        </div>
                        <div class="input-group col-md-3">
                            <label class="col-md-12" for="surname_parent">นามสกุลผู้ปกครอง</label>
                            <input type="text" class="form-input form-input-check col-md-12" disabled v-model="search_student[1].surname_parent">
                        </div>
                        <div class="input-group col-md-3">
                            <label class="col-md-12" for="relation">ความสัมพันธ์</label>
                            <input type="text" class="form-input form-input-check col-md-12" disabled v-model="search_student[1].relation">
                        </div>
                        <div class="input-group col-md-3">
                            <label class="col-md-12" for="phone_parent">เบอร์ผู้ปกครอง</label>
                            <input type="text" class="form-input form-input-check col-md-12" disabled v-model="search_student[1].phone_parent">
                        </div>
                        <div class="input-group col-md-12">
                            <label class="col-md-12" for="qAnswer_1">คำถามข้อ 1</label>
                            <textarea type="text" class="form-input form-input-check col-md-12" disabled v-model="search_student[1].qAnswer_1"></textarea>
                        </div>
                        <div class="input-group col-md-12">
                            <label class="col-md-12" for="qAnswer_2">คำถามข้อ 2</label>
                            <textarea class="form-input form-input-check col-md-12" disabled v-model="search_student[1].qAnswer_2"></textarea>
                        </div>
                    </div>
                    <h3 v-if="search_student[1] == null">ไม่พบเลขประจำตัวนี้</h3>
                </div>
                <div class="admission col-md-10 offset-md-1" :style="{ display: admission_display}">
                    <div class="row">
                        <div class="branch-student col-md-10 col-10 mx-auto">
                            <button @click="branchStudent(branch)" class="col-md-2 col-5 mx-auto" v-for="(branch, index) in ['Graphic', 'Robot', 'Multimedia', 'Programing']" :key="index"> {{ branch }} </button>
                            <div class="w-100"></div>
                            <button @click="branch_display = 'All'" class="col-md-2 col-5 mx-auto">All</button>
                            <button @click="branch_display = 'Religion'" class="col-md-2 col-5 mx-auto">Religion</button>
                            <br>
                            <br>
                            <span style="color: rgb(76, 175, 80);">ยืนยันแล้ว {{ count_admission_confirm }}</span>&nbsp;&nbsp;&nbsp;
                            <span style="color: rgb(220, 53, 69);">ยังไม่ยืนยัน {{ count_admission_not_confirm }}</span>
                        </div>
                        <div class="table-responsive">
                            <table class="table table-hover">
                                <thead class="thead-dark">
                                    <tr>
                                        <th scope="col">#</th>
                                        <th scope="col">ชื่อ-นามสกุล</th>
                                        <th scope="col">ชื่อเล่น</th>
                                        <th scope="col">ชั้น</th>
                                        <th scope="col">สาขา</th>
                                        <th scope="col">ยืนยันสิทธิ์</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(student, index) in students_list" :key="index" v-if="student.branch == branch_display && student.choose == 'real' && student.confirm == true || branch_display == 'All' && student.choose == 'real' && student.confirm == true || branch_display == 'Religion' && student.choose == 'real' && student.confirm == true && student.religion != 'พุทธ'">
                                        <th scope="row">{{ student.studentid }}</th>
                                        <td>{{ student.name }} {{ student.surname }}</td>
                                        <td>{{ student.nickname }}</td>
                                        <td>{{ student.classlevel }}/{{ student.classroom }}</td>
                                        <td>{{ student.branch }}</td>
                                        <td v-if="student.confirm == true" style="color: #4caf50;">ยืนยันแล้ว</td>
                                        <td v-if="student.confirm == null" style="color: #dc3545;">ยังไม่ยืนยัน</td>
                                        <td>
                                            <button class="student-info-btn" v-b-modal="modalId(student.studentid)">รายละเอียด</button>
                                        </td>
                                        <b-modal :id="'modal'+student.studentid" size="lg" :title="'#'+student.studentid+' '+student.name+' '+student.surname+' '+''+'('+student.nickname+')'" hide-footer>
                                            <div class="row">
                                                <div class="input-group col-md-3">
                                                    <label class="col-md-12" for="branch">สาขา</label>
                                                    <input type="text" class="form-input form-input-check col-md-12" disabled v-model="student.branch">
                                                </div>
                                                <div class="input-group col-md-3">
                                                    <label class="col-md-12" for="classlevel">ระดับชั้น</label>
                                                    <input type="text" class="form-input form-input-check col-md-12" disabled v-model="student.classlevel">
                                                </div>
                                                <div class="input-group col-md-3">
                                                    <label class="col-md-12" for="classroom">ห้อง</label>
                                                    <input type="text" class="form-input form-input-check col-md-12" disabled v-model="student.classroom">
                                                </div>
                                                <div class="input-group col-md-3">
                                                    <label class="col-md-12" for="religion">ศาสนา</label>
                                                    <input type="text" class="form-input form-input-check col-md-12" disabled v-model="student.religion">
                                                </div>
                                                <div class="input-group col-md-4">
                                                    <label class="col-md-12" for="phone">เบอร์มือถือ</label>
                                                    <input type="text" class="form-input form-input-check col-md-12" disabled v-model="student.phone">
                                                </div>
                                                <div class="input-group col-md-4">
                                                    <label class="col-md-12" for="lineid">ไลน์</label>
                                                    <input type="text" class="form-input form-input-check col-md-12" disabled v-model="student.lineid">
                                                </div>
                                                <div class="input-group col-md-4">
                                                    <label class="col-md-12" for="fburl">เฟสบุ๊ค</label>
                                                    <input type="text" class="form-input form-input-check col-md-12" disabled v-model="student.fburl">
                                                </div>
                                                <div class="input-group col-md-6">
                                                    <label class="col-md-12" for="medical">โรคประจำตัว</label>
                                                    <input type="text" class="form-input form-input-check col-md-12" disabled v-model="student.medical">
                                                </div>
                                                <div class="input-group col-md-6">
                                                    <label class="col-md-12" for="allergy">สิ่งที่แพ้</label>
                                                    <input type="text" class="form-input form-input-check col-md-12" disabled v-model="student.allergy">
                                                </div>
                                                <div class="input-group col-md-3">
                                                    <label class="col-md-12" for="name_parent">ชื่อผู้ปกครอบ</label>
                                                    <input type="text" class="form-input form-input-check col-md-12" disabled v-model="student.name_parent">
                                                </div>
                                                <div class="input-group col-md-3">
                                                    <label class="col-md-12" for="surname_parent">นามสกุลผู้ปกครอง</label>
                                                    <input type="text" class="form-input form-input-check col-md-12" disabled v-model="student.surname_parent">
                                                </div>
                                                <div class="input-group col-md-3">
                                                    <label class="col-md-12" for="relation">ความสัมพันธ์</label>
                                                    <input type="text" class="form-input form-input-check col-md-12" disabled v-model="student.relation">
                                                </div>
                                                <div class="input-group col-md-3">
                                                    <label class="col-md-12" for="phone_parent">เบอร์ผู้ปกครอง</label>
                                                    <input type="text" class="form-input form-input-check col-md-12" disabled v-model="student.phone_parent">
                                                </div>
                                                <div class="input-group col-md-12">
                                                    <label class="col-md-12" for="qAnswer_1">คำถามข้อ 1</label>
                                                    <textarea type="text" class="form-input form-input-check col-md-12" disabled v-model="student.qAnswer_1"></textarea>
                                                </div>
                                                <div class="input-group col-md-12">
                                                    <label class="col-md-12" for="qAnswer_2">คำถามข้อ 2</label>
                                                    <textarea class="form-input form-input-check col-md-12" disabled v-model="student.qAnswer_2"></textarea>
                                                </div>
                                                <button class="choose-btn" :class="{ 'choose-btn-real-active' : student.choose == 'real'}" @click="chooseStudent(student.studentid, 'real')">ตัวจริง</button>
                                                <button class="choose-btn choose-btn-reserve" :class="{ 'choose-btn-reserve-active' : student.choose == 'reserve'}" @click="chooseStudent(student.studentid, 'reserve')">ตัวสำรอง</button>
                                            </div>
                                        </b-modal>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="certificate col-md-10 offset-md-1" :style="{ display: certificate_display}">
                    <!-- <button @click="certificateGenerator(12048)">Save</button>
                    <div class="certificate_canvas" ref="certificate_canvas">
                        <h3>ทิพย สุพจน์</h3>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import firebase from "firebase";
import jspdf from "jspdf";
export default {
  name: "admin",
  data() {
    return {
      overview_display: "block",
      student_display: "none",
      search_display: "none",
      admission_display: "none",
      certificate_display: "none",

      students_list: [],

      branch_display: "All",

      search_student: [{ studentid: "" }, ""],

      count_graphic: 0,
      count_robot: 0,
      count_multimedia: 0,
      count_programing: 0,
      count: 0,

      count_m1: 0,
      count_m2: 0,
      count_m3: 0,
      count_m4: 0,
      count_m5: 0,
      count_m6: 0,

      count_admission_confirm: 0,
      count_admission_not_confirm: 0
    };
  },
  mounted() {
    firebase
      .database()
      .ref()
      .child("users")
      .once("value", snapshot => {
        snapshot.forEach(child => {
          let count;

          // Add each student in list
          this.students_list.push({
            allergy: child.val().allergy,
            branch: child.val().branch,
            classlevel: child.val().classlevel,
            classroom: child.val().classroom,
            fburl: child.val().fburl,
            lineid: child.val().lineid,
            medical: child.val().medical,
            name: child.val().name,
            name_parent: child.val().name_parent,
            nickname: child.val().nickname,
            phone: child.val().phone,
            phone_parent: child.val().phone_parent,
            qAnswer_1: child.val().qAnswer_1,
            qAnswer_2: child.val().qAnswer_2,
            relation: child.val().relation,
            religion: child.val().religion,
            studentid: child.val().studentid,
            surname: child.val().surname,
            surname_parent: child.val().surname_parent,
            choose: child.val().choose,
            confirm: child.val().confirm
          });

          // Count branch
          if (child.val().branch === "Programing") {
            this.count_programing++;
          } else if (child.val().branch === "Graphic") {
            this.count_graphic++;
          } else if (child.val().branch === "Multimedia") {
            this.count_multimedia++;
          } else if (child.val().branch === "Robot") {
            this.count_robot++;
          }

          // Count classlevel
          if (child.val().classlevel === "ม.1") {
            this.count_m1++;
          } else if (child.val().classlevel === "ม.2") {
            this.count_m2++;
          } else if (child.val().classlevel === "ม.3") {
            this.count_m3++;
          } else if (child.val().classlevel === "ม.4") {
            this.count_m4++;
          } else if (child.val().classlevel === "ม.5") {
            this.count_m5++;
          } else if (child.val().classlevel === "ม.6") {
            this.count_m6++;
          }

          // Count Pass Admission
          if (child.val().confirm === true && child.val().choose === "real") {
            this.count_admission_confirm++;
          } else if (
            child.val().confirm == null &&
            child.val().choose === "real"
          ) {
            this.count_admission_not_confirm++;
          }

          // Count all student
          this.count++;
        });
      });
  },
  methods: {
    logout: function() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$router.replace("login");
        });
    },
    overviewDisplay() {
      this.overview_display = "block";
      this.student_display = "none";
      this.search_display = "none";
      this.admission_display = "none";
      this.certificate_display = "none";
    },
    studentDisplay() {
      this.overview_display = "none";
      this.student_display = "block";
      this.search_display = "none";
      this.admission_display = "none";
      this.certificate_display = "none";
    },
    searchDisplay() {
      this.overview_display = "none";
      this.student_display = "none";
      this.search_display = "block";
      this.admission_display = "none";
      this.certificate_display = "none";
    },
    admissionDisplay() {
      this.overview_display = "none";
      this.student_display = "none";
      this.search_display = "none";
      this.admission_display = "block";
      this.certificate_display = "none";
    },
    certificateDisplay() {
      this.overview_display = "none";
      this.student_display = "none";
      this.search_display = "none";
      this.admission_display = "none";
      this.certificate_display = "block";
    },
    modalId(studentid) {
      return "modal" + studentid;
    },
    searchStudent(search_studentid) {
      this.search_student = [{ studentid: search_studentid }];
      firebase
        .database()
        .ref("users/" + search_studentid)
        .once("value")
        .then(snapshot => {
          this.search_student.push({
            allergy: snapshot.val().allergy,
            branch: snapshot.val().branch,
            classlevel: snapshot.val().classlevel,
            classroom: snapshot.val().classroom,
            fburl: snapshot.val().fburl,
            lineid: snapshot.val().lineid,
            medical: snapshot.val().medical,
            name: snapshot.val().name,
            name_parent: snapshot.val().name_parent,
            nickname: snapshot.val().nickname,
            phone: snapshot.val().phone,
            phone_parent: snapshot.val().phone_parent,
            qAnswer_1: snapshot.val().qAnswer_1,
            qAnswer_2: snapshot.val().qAnswer_2,
            relation: snapshot.val().relation,
            religion: snapshot.val().religion,
            studentid: snapshot.val().studentid,
            surname: snapshot.val().surname,
            surname_parent: snapshot.val().surname_parent
          });
        });
    },
    branchStudent(branch) {
      this.branch_display = branch;
    },
    chooseStudent(studentid, result) {
      // Set choose result to firebase db
      firebase
        .database()
        .ref("users/" + studentid)
        .update({
          choose: result
        });
    }
    // certificateGenerator(studentid) {
    //   var certificate_doc = new jspdf({
    //     orientation: "landscape"
    //   });
    //   var specialElementHandlers = {
    //     "#editor": function(element, renderer) {
    //       return true;
    //     }
    //   };
    // //   certificate_doc.fromHTML(this.$el.certificate_canvas.get(0), 15, 15, {
    // //     width: 170,
    // //     elementHandlers: specialElementHandlers
    // //   });
    //     certificate_doc.fromHTML(this.$el.certificate_canvas.get(0))
    //   certificate_doc.autoPrint();
    //   certificate_doc.save(studentid + "_certificate.pdf");
    // }
  }
};
</script>

<style lang="scss" scoped>
.container-fluid {
  padding: 0;
  & > .row {
    margin: 0;
  }
}

.navbar {
  box-shadow: 0 0 5px #ddd;
  position: relative;
  height: 60px;
  padding: 0;
  z-index: 999;
}

.nav-icon {
  position: absolute;
  left: 20px;
  font-size: 24px;
  line-height: 24px;
  & > i {
    padding: 0 5px;
  }
}

.navbar-title {
  margin: 0;
  text-align: center;
  padding: 0;
}

.navbar-btn {
  position: absolute;
  right: 30px;
  border: 2px solid #212121;
  padding: 3px 7px;
}

/* Sidebar */
.sidebar {
  background: #2c2c2c;
  color: #fff;
  padding: 20px;
  min-height: 100vh;
  & > ul {
    padding-left: 15px;
  }
}

.sidebar-item {
  list-style: none;
  padding: 5px 0;
  cursor: pointer;
}

/* Main */
.main {
  background: #fff;
  padding: 20px;
}

/* Overview */
.branch-container {
  margin: 15px auto;
}

.branch {
  text-align: center;
  box-shadow: 0 0 5px #ddd;
}

.branch-img {
  width: 100%;
  margin-bottom: 10px;
}

.branch-count {
  text-align: center;
  padding: 20px 0;
  margin: 0;
}

.branch-title {
  background: #2c2c2c;
  color: #fff;
  padding: 10px;
  margin: 0;
  font-size: 24px;
}

/* Student */
table {
  & > thead > tr {
    vertical-align: middle;
  }
}

label {
  margin: 0;
  line-height: 30px;
  padding: 0;
}

.table th,
.table td {
  vertical-align: middle;
}

.table-responsive {
  box-shadow: 0 0 5px #ddd;
  margin: 3vh auto;
}

.student-info-btn {
  padding: 3px 6px;
  border: 2px solid;
}

.input-group {
  padding: 5px 10px;
}

.form-input {
  border: 2px solid #2c2c2c;
  border-radius: 3px;
  padding: 5px 10px;
}

.branch-student {
  text-align: center;
  & > button {
    background: #fff;
    border: 2px solid;
    margin-top: 10px;
  }
}

.choose-btn {
  margin: 15px auto 0px;
  border: 2px solid #4caf50;
  background: #fff;
  color: #4caf50;
  padding: 5px 10px;
  transition: 0.1s ease-out;
  cursor: pointer;
  width: 47%;
  &:hover {
    color: #fff;
    background: #4caf50;
  }
}

.choose-btn.choose-btn-reserve {
  color: #ffc107;
  border: 2px solid #ffc107;
  &:hover {
    color: #fff;
    background: #ffc107;
  }
}

.choose-btn-real-active {
  color: #fff;
  background: #4caf50;
}

.choose-btn-reserve-active {
  color: #fff !important;
  background: #ffc107;
}

/* Search */
.search-box {
  position: absolute;
  right: 0px;
  text-align: right;
  & > input {
    padding: 5px;
    border: 2px solid;
  }
  & > button {
    padding: 7px 15px;
    background: #2c2c2c;
    color: #fff;
    border: 0;
  }
}

// Certificate
.certificate {
  & > .certificate_canvas {
    background: url("/static/assets/img/certificate/certificate.png");
    width: 100%;
    height: 600px;
    background-size: cover;
    & > h3 {
      text-align: center;
      position: relative;
      top: 261px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin.vue